import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ProductsComponent } from './products.component';

const routes: Routes = [


	{ path: ':name/pr', component: ProductsComponent },
	


	{ path: 'search/:search', component: ProductsComponent },

	{ path: 'custom/:search', component: ProductsComponent },
	{
		path: 'products',
		component: ProductsComponent
	},

	{
		path: 'products-list/:header',
		component: ProductsComponent
	},
	// {
	// 	path: ' :productId/:categoryId',
	// 	component: ProductsComponent
	// },



];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class ProductsRoutingModule { }
